import { Component, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { UsedSgkz030aService } from '../services/used-sgkz030a.service';
import { takeUntil } from 'rxjs/operators';
import { SgAriaMessage } from '../../../models/sg-aria-message';

/**
 * 登録履歴モーダル画面
 * @example
 * UsedusedSgkz030aServiceをDIして画面情報を設定し、本コンポーネントに遷移する
 * 
 * 【呼び出し元】
 * constructor(private dialog: MatDialog) { }
 * 
 * const dialogRef = this.dialog.open(Sgkz004dComponent, {
 *   data: {historyManagementGroup: 'historyManagementGroup', historyManagementKey: 'historyManagementKey', apprvOnFlg: '1'}
 * });
 * dialogRef.afterClosed().subscribe((result) => {});
 * 
 * @export
 * @class Sgkz004dComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-sgkz004d',
  templateUrl: './sgkz004d.component.html',
  styleUrls: ['./sgkz004d.component.scss'],
})
export class Sgkz004dComponent implements OnInit, OnDestroy {

  @Output() errorMessageModelArray: Array<SgAriaMessage>;

  width = 980;
  height = 548;

  /** モーダル画面表示項目 */
  regperSoshikiName: string = '';
  regpernm: string = '';
  regDate: string = '';
  updaterSoshikiName: string = '';
  updaternm: string = '';
  updateDate: string = '';
  apprvrSoshikiName: string = '';
  apprvrnm: string = '';
  apprvDate: string = '';
  apprvOnFlg: string = '0';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  constructor(
    private ref: MatLegacyDialogRef<Sgkz004dComponent>,
    private usedSgkz030aService: UsedSgkz030aService,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
  ) { }

  /**
   * 初期処理
   * @memberof Sgkz004dComponent
   */
  ngOnInit(): void {

    this.usedSgkz030aService.search(this.data.historyManagementGroup, this.data.historyManagementKey);

    // 登録履歴情報更新
    this.usedSgkz030aService.getSgkz030aResponse.pipe(takeUntil(this.onDestroy$)).subscribe(response => {
      this.regperSoshikiName = response.regperSoshikiName;
      this.regpernm = response.regpernm;
      this.regDate = response.regDate;
      this.updaterSoshikiName = response.updaterSoshikiName;
      this.updaternm = response.updaternm;
      this.updateDate = response.updateDate;
      this.apprvrSoshikiName = response.apprvrSoshikiName;
      this.apprvrnm = response.apprvrnm;
      this.apprvDate = response.apprvDate;
    });

    // 承認者欄フラグ更新
    this.apprvOnFlg = this.data.apprvOnFlg;

    // 画面サイズ調整
    if (this.data.apprvOnFlg === '0') {
      this.height = 415;
    }
  }

  /**
   * 後処理
   * @memberof Sgkz004dComponent
   */
  ngOnDestroy(): void {
    this.regperSoshikiName = '';
    this.regpernm = '';
    this.regDate = '';
    this.updaterSoshikiName = '';
    this.updaternm = '';
    this.updateDate = '';
    this.apprvrSoshikiName = '';
    this.apprvrnm = '';
    this.apprvDate = '';
    this.apprvOnFlg = '0';
  }

  /**
   * モーダルウィンドウを閉じる
   * @memberof Sgkz004dComponent
   */
  close(): void {
    this.ref.close();
  }
}

